var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTransactionHash(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 57,
    height: 58,
    viewBox: "0 0 57 58",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_7959_151004)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 19.583C0 4.25819 3.28455 0.973633 18.6094 0.973633H37.4429C52.7677 0.973633 56.0523 4.25819 56.0523 19.583V38.4166C56.0523 53.7414 52.7677 57.0259 37.4429 57.0259H18.6094C3.28455 57.0259 0 53.7414 0 38.4166V19.583Z",
    fill: "#E5B910"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M70.0653 35.0182C70.0653 52.2266 56.5137 66.1767 39.797 66.1767C23.0804 66.1767 9.52881 52.2266 9.52881 35.0182C9.52881 17.8099 16.7932 51.3793 39.797 23.4451C56.5137 23.4451 70.0653 17.8099 70.0653 35.0182Z",
    fill: "#25346A"
  }), /*#__PURE__*/React.createElement("path", {
    opacity: 0.4,
    d: "M33.0718 48.7007C33.0718 43.702 37.0083 39.6497 41.8641 39.6497C46.72 39.6497 50.6565 43.702 50.6565 48.7007C50.6565 53.6994 46.72 52.0625 41.8641 52.0625C37.0083 52.0625 33.0718 53.6994 33.0718 48.7007Z",
    fill: "white"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_7959_151004"
  }, /*#__PURE__*/React.createElement("rect", {
    y: 0.973633,
    width: 56.0523,
    height: 56.0523,
    rx: 13.4525,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTransactionHash);
export default __webpack_public_path__ + "static/media/transaction-hash.323653006666e5629fcad2c118a685ee.svg";
export { ForwardRef as ReactComponent };